<template>
	<!-- json字符串 -->
	<el-container>
		<div style="margin-bottom: 15px;">
			<el-button-group>
				<el-button type="primary" @click="formatter">格式化内容</el-button>
				<el-button type="primary" @click="zipped">压缩</el-button>
				<el-button type="primary" @click="unicodeToChinese">Unicode转中文</el-button>
				<el-button type="primary" @click="chineseToUnicode">中文转Unicode</el-button>
				<el-button type="primary" @click="escaping">转义</el-button>
				<el-button type="primary" @click="antisense">反转义</el-button>
			</el-button-group>
		</div>
		<el-row class="wl-main" :gutter="10">
			<el-col :span="12">
				<el-card class="text-container">
					<editor v-model="textarea2"
						@init="editorInit"
						:options="{wrap: true}"
						lang="json"
						:theme="editorTheme"
						width="100%"
						height="100%">
					</editor>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card>
					<!-- 第二种，比较完善，数据量大也没事，就是样子没第一种好看 -->
					<!-- https://github.com/leezng/vue-json-pretty/tree/v1.7.1 -->
					<!-- <vue-json-pretty
						:data="jsonData"
						:deep="5"
						:highlightMouseoverNode="true"
						:showLine="false"
						:showDoubleQuotes="true"
						:showSelectController="false"
						:showLength="true"
					>
					</vue-json-pretty> -->
					<editor v-model="jsonData"
						@init="editorInit"
						:options="{wrap: true, readOnly:false}"
						lang="json"
						:theme="editorTheme"
						width="100%"
						height="100%">
					</editor>
				</el-card>
			</el-col>
		</el-row>
	</el-container>
</template>

<script>
	export default {
		name: "g-jsonformat",
		data() {
			return {
				textarea2: '',
				jsonData: '',
			};
		},
		components: {
			editor: require('vue2-ace-editor'),
		},
		watch: {
			
		},
		created(){
			if(process.env.NODE_ENV=='development'){
				this.textarea2 = `{"answer":{"answerType":"GenQA","emotion":"default","question":{"question":"浮云打开原唱","question_ws":"浮云/NN//  打开/VI//  原唱/NN//"},"text":"我得癌症了，懒癌，你自己动手吧。","topicID":"NULL","type":"T"},"no_nlu_result":0,"operation":"ANSWER","rc":0,"service":"iFlytekQA","serviceCategory":"GenQA","serviceName":"iFlytekQA","serviceType":"preventive","sid":"cida17370cb@dx000b1594906201000e","text":"浮云打开原唱","uuid":"cida17370cb@dx000b1594906201000e","voice_answer":[{"content":"我得癌症了，懒癌，你自己动手吧。","type":"TTS"}]}`
			}
		},
		methods: {
			toJson(val, isTips=true) {
				if(val==''){
					this.jsonData = ""
				}else{
					try {
						this.jsonData = this.jsonFormat(val);
						return true
					} catch (error) {
						if(isTips){
							this.$message.error("不是正常的 JSON 格式");
						}
						return false
					}
				}
			},
			
			// Unicode转中文汉字
			reconvert(str){
			    str = str.replace(/(\\u)(\w{1,4})/gi,function($0){
			        return (String.fromCharCode(parseInt((escape($0).replace(/(%5Cu)(\w{1,4})/g,"$2")),16)));
			    });
			    str = str.replace(/(&#x)(\w{1,4});/gi,function($0){
			        return String.fromCharCode(parseInt(escape($0).replace(/(%26%23x)(\w{1,4})(%3B)/g,"$2"),16));
			    });
			    str = str.replace(/(&#)(\d{1,6});/gi,function($0){
			        return String.fromCharCode(parseInt(escape($0).replace(/(%26%23)(\d{1,6})(%3B)/g,"$2")));
			    });
			    return str;
			},
			// 转为 Unicode 编码  
			encodeUnicode(str) {  
				let reg = /[\u4e00-\u9fa5]/g;
				let list = str.match(reg);
				if(!list){
					return str
				}
				
				let newArr = []
				for (var i = 0; i < list.length; i++) {
					if (newArr.indexOf(list[i]) === -1) {
						newArr.push(list[i])
					}
				}
				for(let i in newArr){
					str = str.replace(eval('/'+newArr[i]+'/ig'), '\\u' + this.left_zero_4(parseInt(newArr[i].charCodeAt(0)).toString(16)));
				}
				return str;
			},
			left_zero_4(str) {
				if (str != null && str != '' && str != 'undefined') {
					if (str.length == 2) {
						return '00' + str;
					}
				}
				return str;
			},
			
			// 格式化内容
			formatter(){
				this.toJson(this.textarea2);
			},
			// 压缩
			zipped(){
				if(this.toJson(this.textarea2)){
					this.jsonData = this.jsonFormat(this.textarea2, true);
				}
			},
			// Unicode转中文
			unicodeToChinese(){
				if(this.toJson(this.textarea2, false)){
					this.jsonData = this.jsonFormat(this.textarea2);
					this.jsonData = this.reconvert(this.jsonData);
				}else{
					this.jsonData = this.reconvert(this.textarea2);
				}
			},
			// 中文转Unicode
			chineseToUnicode(){
				if(this.toJson(this.textarea2, false)){
					this.jsonData = this.jsonFormat(this.textarea2);
					this.jsonData = this.encodeUnicode(this.jsonData);
				}else{
					this.jsonData = this.encodeUnicode(this.textarea2);
				}
			},
			// 转义
			escaping(){
				if(this.toJson(this.textarea2, false)){
					this.jsonData = this.jsonFormat(this.textarea2);
					this.jsonData = this.jsonData.replace(/\"/g, '\\\"');
				}else{
					this.jsonData = this.textarea2.replace(/\"/g, '\\\"');
				}
			},
			// 反转义
			antisense(){
				if(this.toJson(this.textarea2, false)){
					this.jsonData = this.jsonFormat(this.textarea2);
					this.jsonData = this.jsonData.replace(/\\\"/gi, '\"');
				}else{
					this.jsonData = this.textarea2.replace(/\\\"/gi, '\"');
				}
			}
		
		},
		mounted() {
			
		},
	};
</script>

<style lang="scss" scoped>
	.el-container /deep/{
		height: 100%;
		display: flex;
		flex-flow: column;
		flex:1;
		
		.wl-main{
		    display: flex;
			flex:1;
			
			.el-col{
				display: flex;
				flex:1;
			}
			
			.el-card{
				display: flex;
				flex:1;
				
				.el-card__body{
					display: flex;
					flex-flow: column;
					flex:1px;
					height: 100%;
					
					// 显示插件
					.vjs-tree__node{
						padding-left: 0px;
						
						.vjs-tree__indent{
							flex: 0 0 2em;
						}
						.vjs-key+span{
							margin-left: 5px;
						}
					} 
				}
			}
			
			.text-container{
				display: flex;
				flex-flow: column;
				flex:1px;
				height: 100%;
				
				.el-textarea{
					display: flex;
					flex-flow: column;
					flex:1px;
					height: 100%;
					
					textarea{
						display: flex;
						flex-flow: column;
						flex:1px;
					}
				}
			}
		}
	}
</style>
